'use strict'

urlUpdate = require '../../page/frontend/helpers/url_update'
{ itemExists } = require './helpers/local_storage'
{ createTaxonomyPreferencesModel } = require './helpers/taxonomy_preferences_model'
CardUI = require 'grpn-card-ui/frontend/init'
CardsView = require '../../browse/frontend/views/cards'
errorViewHtml = require '../../browse/frontend/views/error_html'
HomeRelated = require '../../browse/frontend/model/related'
LocationRemembrance = require '../../browse/frontend/location_remembrance'
PaginationFooter = require './views/pagination'
spinnerGroup = require '../../page/frontend/helpers/spinner_group'
ViewNoCards = require '../../browse/frontend/views/no_cards'
domConfig = require '../../page/frontend/helpers/dom_config'
WidgetModel = require './model/widget'
SponsoredDealsWidgetModel = require './model/sponsored_deals_widget'
SponsoredDealsWidgetView = require '../../page/frontend/views/sponsored_deals_widget'
BottomWidgetView = require '../../page/frontend/views/bottom_widget'
{isFeatureEnabled, isInTreatment} = require '../../page/frontend/helpers/finch'
AppDownloadWidgetView = require '../../app_download_widget/frontend/views/app_download_widget'
DealFetcher = require '../../page/frontend/views/deal_fetcher'
isScrolledPastElement = require '../../page/frontend/helpers/is_scrolled_past_element'
{ isInUS } = require '../../page/frontend/helpers/division'
{ showTaxonomyDialog, onUserClickedTaxonomyTile } = require './helpers/taxonomy_preferences_dialog_loader'
jsonParser = require '../../utils/json_parser'

SELECTORS =
  CARDS_WRAPPER: '#pull-results'
  CARDS: '#pull-cards'
  PAGINATION: '#pull-pagination'
  NOCARDS: '#pull-no-cards'
  CARDSERROR: '#pull-oops-error'
  NOCARDS_MESSAGE: '.notification.info.no-cards'
  NOCARDS_MESSAGE_GETAWAYS: '.getaways_notification'
  CARD_IMAGES: '.cui-c-udc .cui-image'
  WIDGET_VIEW_CONTAINER: '#pull-widget-container'
  WIDGET_VIEW: '#pull-widget'
  FEATURED_CARDS: '.cui-c-udc-featured, .cui-c-udc-featured-fallback'
  EMBEDDED_CARDS: '.cui-c-compound .cui-c-udc'
  HORIZONTAL_NAVIGATION: '.cui-c-navigation.cui-c-navigation-horizontal'
  PAGINATION_CONTAINER: '#pull-pagination-container'
  APP_DOWNLOAD_WIDGET_CONTAINER: '#app-download-widget'
  BELOW_FOLD_RVD:'#pull-cards [data-embed-permalink="/cardatron/home/touch-rvd-container-partial"]'
  PENCIL_BANNER: '#pull-cards .cui-c-banner'
  CARD_FEED_SEPARATOR: '#pull-cards .homepage-title'
  SPONSORED_DEALS_WIDGET_VIEW: '#pull-sponsored-deals-widget'

module.exports = _.extend {}, Backbone.Events,
  defaults:
    urlParams: {}
    xhrParams: {}
    spinnerRunning: false

  initialize: ->
    @_initCardUI()
    @domConfig = domConfig.get() ? {}
    LocationRemembrance.initialize('home:dealClickedId')
    $(document).ready => @onReady()
    $(window).one 'load', => @onLoad()
    $(window).resize => _.debounce(@truncateElements(), 200)
    window.onpopstate = => @_onPopState()

    @enabledFeatures = @domConfig.enabledFeatures
    @paginationElement = document.querySelector(SELECTORS.PAGINATION_CONTAINER)
    @viewAllDealsElement = document.querySelector(SELECTORS.VIEW_ALL_DEALS_CONTAINER)
    showTaxonomyDialog = showTaxonomyDialog.bind(this)
    createTaxonomyPreferencesModel = createTaxonomyPreferencesModel.bind(this)

  truncateElements: ->
    GIG.Utils.truncateElements()

  onReady: ->
    LocationRemembrance.scrollToLastClickedDeal()
    $(SELECTORS.PAGINATION).show()
    @showSubscriptionSuccessNotification()

  onLoad: ->
    @_setDefaults()
    @_createModelsAndViews()
    @_addListeners()
    @_lazyLoadVideo()
    @_loadTaxonomyDialog()
    @_lazyLoadDeals()

  _loadTaxonomyDialog: ->
    return if itemExists('shownTaxonomyPreferences')
    showTaxonomyDialog(!!@domConfig.enabledFeatures?.showTaxonomyPreferences, GIG.Modal, onUserClickedTaxonomyTile)

  _lazyLoadDeals: ->
    return unless @domConfig.enabledFeatures.isLazyLoadedHomepage
    @_updateParams(Groupon.Utils.unparam())

    if window.history.state
      {selectedDealBhc, sanitizedCardsHtml, paginationHash} = window.history.state

      if !!sanitizedCardsHtml
        paginationHash = jsonParser.parseEscapedString(paginationHash) if paginationHash
        @_updateCards {cardsHtml: sanitizedCardsHtml, paginationHash}, {isLazyLoaded: true}

        deal = document.querySelector(".cui-c-udc[data-bhc='" + selectedDealBhc + "']")
        deal?.scrollIntoView()
        return

    @dealFetcher.fetchDeals(@xhrParams)
      .then (data) =>
        @_onLazyLoadedDealsFetchedHandler(data)
      .catch (response) =>
        @_onLazyLoadedDealsFetchedErrorHandler(response)

  _onLazyLoadedDealsFetchedHandler: (data) ->
    {cardsHtml, noCardsHtml} = data
    if not _.isEmpty(cardsHtml)
      @_updateCards data, {isLazyLoaded: true, updateCardsListener: true}
    else if not _.isEmpty(noCardsHtml)
      @_updateNoCards noCardsHtml
    else
      @_onDealsFetchedErrorHandler(data)

  _onLazyLoadedDealsFetchedErrorHandler: (response) ->
    $(SELECTORS.CARDSERROR).html errorViewHtml.render()
    @_showError()

  showSubscriptionSuccessNotification: ->
    hash = @getCookie('subscription_success_hash')
    return null unless hash?

    try
      {email_address, division} = JSON.parse(decodeURIComponent(hash))
    catch
      @unsetCookie('subscription_success_hash')

    return unless email_address? and division?

    message = @getNotificationMessage(division, email_address)

    notification = $('#subscripitonSuccessNotification')
    notification.append(message)

    $('#global-container').prepend(notification)
    notification.show()
    notification.delay(3000).slideUp()
    @unsetCookie('subscription_success_hash')

  getCookie: (key) ->
    window.Cookie.get(key)

  unsetCookie: (key) ->
    window.Cookie.unset(key)

  getNotificationMessage: (division, email) ->
    I18n.translate 'js.modules.home.subscribeSuccessMessage', {
      division,
      email
    }

  _setDefaults: ->
    @defaults.xhrParams = _.omitUndefined
      _csrf: @domConfig.csrfToken

  _createModelsAndViews: ->
    @relatedModel = new HomeRelated()
    @taxonomyPreference = createTaxonomyPreferencesModel(itemExists('shownTaxonomyPreferences'), @domConfig.enabledFeatures?.showTaxonomyPreferences)
    @cardsView = new CardsView el: SELECTORS.CARDS
    @noCardsView = new ViewNoCards el: SELECTORS.NOCARDS
    @paginationView = new PaginationFooter el: SELECTORS.PAGINATION
    @appDownloadWidgetView = new AppDownloadWidgetView el: SELECTORS.APP_DOWNLOAD_WIDGET_CONTAINER
    @dealFetcher = new DealFetcher('/partial/homepage/paginated-cards', @defaults.xhrParams)

    @_setupBottomWidget()
    @_setupSponsoredDealsWidget()

  _lazyLoadVideo: ->
    videoCard = document.querySelector(".card-ui.cui-c-collection-tile iframe")

    return unless videoCard?

    lazyLoadSrc = videoCard.getAttribute('data-src')

    return unless lazyLoadSrc
    videoCard.setAttribute('src', lazyLoadSrc)
    videoCard.removeAttribute('data-src')

  _setupBottomWidget: ->
    @widgetModel = new WidgetModel()
    @bottomWidgetView = new BottomWidgetView
      el: SELECTORS.WIDGET_VIEW
      model: @widgetModel
      _csrf: @domConfig.csrfToken
      _hasShownRVD: document.querySelector('[data-embed-permalink="/cardatron/home/touch-rvd-container-partial"]')?

  _setupSponsoredDealsWidget: ->
    @sponsoredDealsWidgetModel = new SponsoredDealsWidgetModel()
    @sponsoredDealsWidgetView = new SponsoredDealsWidgetView
      el: SELECTORS.SPONSORED_DEALS_WIDGET_VIEW
      model: @sponsoredDealsWidgetModel
      _csrf: @domConfig.csrfToken

  _addListeners: ->
    @lastClickedDeal = LocationRemembrance.getLastDealId()

    if @lastClickedDeal and @_canShowRelatedDeals()
      @listenTo @relatedModel, 'sync', @_onRelatedSync
      @_updateRelated()

    if @paginationView
      @listenTo @paginationView, 'click:paginationLink', @_onPaginationClick

    @_addPaginationScrollListener()

  _onRelatedSync: ->
    @_renderRelatedDeals @relatedModel.toJSON()

  _renderRelatedDeals: (relatedModel) ->
    {relatedDealsHtml} = relatedModel

    return unless relatedDealsHtml and @clickedDealCard
    visibleNotFeaturedCards = @_getVisibleNotFeaturedOrCompound()
    clickedDealIndex = visibleNotFeaturedCards.index(@clickedDealCard)

    return unless clickedDealIndex > -1

    if isInTreatment('TTD_YMALForDealViews_Q218_1', 'Treatment')
      rowIndex = clickedDealIndex + (3 - clickedDealIndex % 3)
      insertAfter = visibleNotFeaturedCards[rowIndex - 1]
      $(insertAfter).attr('data-pointer', clickedDealIndex % 3)
      @cardsView.insertAfter relatedDealsHtml, $(insertAfter)

    if isFeatureEnabled('TTDshowYMALCarousel')
      CardUI.init()

  _canShowRelatedDeals: ->
    @domConfig.enabledFeatures?.showYMALCarousel ? false

  _getVisibleNotFeaturedOrCompound: ->
    $(SELECTORS.CARDS).find(".cui-c-udc:not(#{SELECTORS.FEATURED_CARDS}):not(#{SELECTORS.EMBEDDED_CARDS})")

  _updateRelated: ->
    return unless @lastClickedDeal
    return unless @clickedDealCard = @_getVisibleNotFeaturedOrCompound()?.filter(".cui-c-udc[data-bhc='" + @lastClickedDeal + "']")
    return if @clickedDealCard.hasClass('is-clo')

    @relatedModel.fetch
      data:
        _csrf: @domConfig.csrfToken
        currentDeal: @lastClickedDeal.replace('deal:', '')

  _addPaginationScrollListener: ->
    if isInUS()
      return

    cardContainer = document.querySelector(SELECTORS.CARDS)

    @_handlePaginationBucketing = =>
      if isScrolledPastElement(cardContainer)
        isFeatureEnabled('showHomepageImmediatePaginationInternational')
        window.removeEventListener('scroll', @_handlePaginationBucketingDebounced)

    if isScrolledPastElement(cardContainer)
      isFeatureEnabled('showHomepageImmediatePaginationInternational')
    else
      @_handlePaginationBucketingDebounced = _.debounce(@_handlePaginationBucketing, 200)
      window.addEventListener('scroll', @_handlePaginationBucketingDebounced)

  _onPopState: ->
    newParams = Groupon.Utils.unparam()
    # Some browsers (like Safari) will fire an initial popstate event
    # on page load, and we don't want to fire off searches etc
    # in that case (or anytime params haven't updated)
    return if _.isEqual(newParams, @urlParams)
    @_updateParams(newParams)
    @_scrollThenFetchDeals()

  _onPaginationClick: (event) ->
    newUrlParams = Groupon.Utils.unparam(event.currentTarget.href.split("?")[1] ? '')
    @_updateParams(newUrlParams)
    @_updateUrl({ pushState: true })
    @_scrollThenFetchDeals()

  _scrollToHorizontalNavigation: ->
    scrollToPosition = $(SELECTORS.HORIZONTAL_NAVIGATION).offset()?.top
    $(document).scrollTop(scrollToPosition)

  _showCards: ->
    $(SELECTORS.CARDS).show()
    $(SELECTORS.PAGINATION).show()
    $(SELECTORS.CARDSERROR).hide()
    $(SELECTORS.NOCARDS).hide()

  _addCardOnMouseDownListener: (cardsHtml, paginationHash) ->
    (card) ->
      card.classList.add('has-location-rememberance-listener')
      card.addEventListener 'mousedown', (event) ->
        if cardsHtml && cardsHtml.length
          sanitizedCardsHtml = cardsHtml.replace(/has-scroll-listener|has-viewportenter-listener|has-location-rememberance-listener/g, '')
          selectedDealBhc = this?.dataset?.bhc
          paginationHash = JSON.stringify(paginationHash)
          window.history?.replaceState?({sanitizedCardsHtml, selectedDealBhc, paginationHash}, null, window.location.href)

  _updateCards: (searchResults, options = {}) ->
    {cardsHtml, paginationHash} = searchResults
    {isLazyLoaded, updateCardsListener} = options

    isFirstPage = @urlParams?.page is undefined or @urlParams?.page is '1'

    @_hideFirstPageOnlyNonFeedCards() if !isFirstPage or (isFirstPage and isLazyLoaded)
    @_replaceCardsFeedUnderHorizontalNavigation(cardsHtml)
    @_showFirstPageOnlyNonFeedCards() if isFirstPage

    @_showCards()

    if @paginationView
      @paginationView.render presentedHash: paginationHash

    @_initCardUI()
    # https://jira.groupondev.com/browse/ION-7882
    _.delay (=> @_forceImageToLoad()), 1000

    if updateCardsListener and @domConfig.enabledFeatures.isLazyLoadedHomepage
      allCards = document.querySelectorAll('.card-ui:not(.has-location-rememberance-listener)')
      onMouseDownListener = @_addCardOnMouseDownListener(cardsHtml, paginationHash)
      allCards.forEach(onMouseDownListener) if allCards.length

    @_stopSpinner()

  _replaceCardsFeedUnderHorizontalNavigation: (cardsHtml) ->
    $(SELECTORS.HORIZONTAL_NAVIGATION).nextAll(':not(.is-hidden)').remove()
    $(SELECTORS.CARDS).append(cardsHtml)

  _hideFirstPageOnlyNonFeedCards: ->
    document.querySelector(SELECTORS.BELOW_FOLD_RVD)?.classList.add('is-hidden')
    document.querySelector(SELECTORS.PENCIL_BANNER)?.classList.add('is-hidden')
    document.querySelector(SELECTORS.CARD_FEED_SEPARATOR)?.classList.add('is-hidden')

  _showFirstPageOnlyNonFeedCards: ->
    document.querySelector(SELECTORS.BELOW_FOLD_RVD)?.classList.remove('is-hidden')
    document.querySelector(SELECTORS.PENCIL_BANNER)?.classList.remove('is-hidden')
    document.querySelector(SELECTORS.CARD_FEED_SEPARATOR)?.classList.remove('is-hidden')

  _startSpinner: ->
    spinnerGroup.start 'search',
      el: SELECTORS.CARDS_WRAPPER
    @spinnerRunning = true

  _stopSpinner: ->
    GIG.Utils.truncateElements($(SELECTORS.CARDS), { watch: false })
    return unless @spinnerRunning
    spinnerGroup.stop 'search'
    @spinnerRunning = false

  _showError: ->
    $(SELECTORS.CARDSERROR).show()
    $(SELECTORS.CARDS).hide()
    $(SELECTORS.PAGINATION).hide()
    $(SELECTORS.NOCARDS).hide()

  _showNoCards: ->
    $(SELECTORS.NOCARDS).show()
    $(SELECTORS.CARDS).hide()
    $(SELECTORS.PAGINATION).hide()
    $(SELECTORS.CARDSERROR).hide()

  _updateNoCards: (noCardsHtml) ->
    @noCardsView.render noCardsHtml
    @_showNoCards()
    @_stopSpinner()

  _setParams: (params) ->
    @urlParams = _.extend {}, @defaults.urlParams, params
    @xhrParams = _.extend {}, @defaults.xhrParams, params

  _updateParams: (newUrlParams = {}) ->
    return if _.isEqual(newUrlParams, @urlParams)
    @_setParams(newUrlParams)
    @urlParams = _.omitUndefined(@urlParams)

  _updateUrl: (opts = {}) ->
    paramString = $.param @urlParams
    updatedUrl = window.location.pathname
    if paramString.length
      updatedUrl += "?#{paramString}"
    urlUpdate.update(updatedUrl, opts)

  _scrollThenFetchDeals: ->
    @_scrollToHorizontalNavigation()
    @_fetchDeals()

  _fetchDeals: ->
    @_startSpinner()

    params = _.extend {}, @xhrParams, Groupon.Utils.unparam()

    @dealFetcher.fetchDeals(params)
      .then (data) =>
        @_onDealsFetchedHandler(data)
        @dealFetcher.addPreloadNextPageScrollListener()
      .catch (response) =>
        @_onDealsFetchedErrorHandler(response)

  _onDealsFetchedHandler: (data) ->
    {cardsHtml, noCardsHtml} = data
    if not _.isEmpty(cardsHtml)
      @_updateCards data, {updateCardsListener: true}
    else if not _.isEmpty(noCardsHtml)
      @_updateNoCards noCardsHtml
    else
      @_onDealsFetchedErrorHandler(data)

  _onDealsFetchedErrorHandler: ->
    $(SELECTORS.CARDSERROR).html errorViewHtml.render()
    @_showError()
    @_stopSpinner()

  _initCardUI: ->
    CardUI.init()

  _forceImageToLoad: ->
    return unless firstImage = $(SELECTORS.CARD_IMAGES)[0]
    return unless firstImage.getAttribute('src').lastIndexOf('data:', 0) is 0
    @_initCardUI()
